import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import FavoriteIcon from '@material-ui/icons/Favorite';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import ChatBubbleIcon from '@material-ui/icons/ChatBubble';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import { Form, FormInput } from '../../core/Formikfy';
import SendIcon from '@material-ui/icons/Send';
import { db, storage } from '../../firebase';

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    margin: '30px 0',
    width: '100%',
  },
  mediaVideo: {
    [theme.breakpoints.down('sm')]: {
      height: '200px',
    },
    [theme.breakpoints.up('sm')]: {
      height: '400px',
    },
    // 16:9
  },
  mediaImage: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  likes: {
    marginRight: 'auto',
  },
  large: {
    [theme.breakpoints.down('sm')]: {
      width: theme.spacing(7),
      height: theme.spacing(7),
    },
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(10),
      height: theme.spacing(10),
    },
  },
  root: {
    [theme.breakpoints.down('sm')]: {
      padding: '5px',
    },
  },
  comment: {
    [theme.breakpoints.down('sm')]: {
      padding: '5px',
    },
  },
  commentAvatar: {
    [theme.breakpoints.down('sm')]: {
      width: theme.spacing(5),
      height: theme.spacing(5),
    },
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(7),
      height: theme.spacing(7),
    },
  },
  contentHeading: {
    textAlign: 'left',
    fontWeight: 600,
    color: '#3C4858',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8rem',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '1rem',
    },
  },
  contentSubHeading: {
    textAlign: 'left',
    fontWeight: 500,
    color: '#3C4858',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8rem',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '1rem',
    },
  },
  form: {
    width: '100%',
  },
  commentGridItem: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: '200px',
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: '100%',
    },
    marginLeft: '10px',
    textAlign: 'left',
  },
  paper: {
    maxWidth: 200,
    margin: `${theme.spacing(1)}px auto`,
    padding: theme.spacing(2),
  },
}));

export const FeedCard = (props) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const [postRenderInfo, setPostRenderInfo] = useState<any>();
  const [comment, setComment] = useState('');
  const [render, setRender] = useState(false);
  const { postDetails, currentUser, profileInfo } = props;

  useEffect(() => {
    setPostRenderInfo(postDetails);
    if (postDetails.likes.includes(currentUser.uid)) {
      setIsLiked(true);
    }
  }, []);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  const updateDetails = (comment) => {
    const post = postDetails;
    post.comments.push({
      dp: profileInfo.dp_url,
      name: `${profileInfo.firstName} ${profileInfo.lastName}`,
      comment: comment,
    });
    setRender(true);
    setPostRenderInfo(post);
  };
  const likeHandler = async () => {
    const likes = postDetails.likes;
    likes.push(currentUser.uid);
    setIsLiked(true);
    const response = await db.collection('feed').doc(postDetails.post_id).update({
      likes: likes,
    });
  };

  if (!postRenderInfo) {
    return <div></div>;
  }
  return (
    <Card raised={true} className={classes.cardRoot}>
      <CardHeader
        avatar={<Avatar src={postRenderInfo.dp} className={classes.large} />}
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title={postRenderInfo.name}
        subheader={postRenderInfo.uploaded_date.toDate().toDateString()}
        classes={{ root: classes.root }}
      />
      <CardContent>
        <Typography variant="body2" color="textPrimary" component="p">
          {postRenderInfo.description}
        </Typography>
      </CardContent>
      {postRenderInfo.media.type.substr(0, postRenderInfo.media.type.indexOf('/')) === 'image' ? (
        <CardMedia className={classes.mediaImage} image={postRenderInfo.media.url} title="image" />
      ) : (
        <CardMedia
          component="video"
          className={classes.mediaVideo}
          src={postDetails.media.url}
          title="video"
          autoPlay
          controls
        />
      )}

      <CardActions disableSpacing>
        {isLiked ? (
          <FavoriteIcon style={{ margin: '12px' }} color="secondary" />
        ) : (
          <IconButton onClick={likeHandler} aria-label="add to favorites">
            <FavoriteBorderIcon />
          </IconButton>
        )}
        <IconButton className={classes.likes} aria-expanded={expanded} aria-label="show more">
          <Typography>
            {postRenderInfo.likes.length !== 0 && `${postRenderInfo.likes.length}`}
          </Typography>
        </IconButton>
        <IconButton onClick={handleExpandClick} aria-label="share">
          {expanded ? <ChatBubbleIcon /> : <ChatBubbleOutlineIcon />}
        </IconButton>
        <IconButton
          onClick={handleExpandClick}
          style={{ padding: 0 }}
          aria-label="add to favorites"
        >
          <Typography>
            {postRenderInfo.comments.length !== 0 &&
              `${postRenderInfo.comments.length} ${
                postRenderInfo.comments.length === 1 ? 'comment' : 'comments'
              }`}
          </Typography>
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          {postRenderInfo.comments.length > 0 &&
            postRenderInfo.comments.map((comment) => (
              <Grid container wrap="nowrap" spacing={3}>
                <Grid item xs={2} md={1}>
                  <Avatar src={comment.dp} />
                </Grid>
                <Grid item xs={10} md={11}>
                  <Typography variant="h6" className={classes.contentHeading}>
                    {comment.name}
                  </Typography>
                  <Typography variant="h6" className={classes.contentSubHeading}>
                    {comment.comment}
                  </Typography>
                  <Divider light style={{ margin: '5px' }} />
                </Grid>
              </Grid>
            ))}
          <Form
            className={classes.form}
            initialValues={{
              comment: comment,
            }}
            onSubmit={async (data) => {
              setComment('');
              const response = await db
                .collection('feed')
                .doc(postDetails.post_id)
                .update({
                  comments: [
                    ...postRenderInfo.commentsData,
                    { commenter_id: currentUser.uid, comment: data.comment },
                  ],
                });
              console.log(response);
              updateDetails(data.comment);
            }}
          >
            <Grid container spacing={2} wrap="nowrap" alignItems="center">
              <Grid item xs={2}>
                <Avatar src={profileInfo.dp_url} />
              </Grid>
              <Grid item xs={8} style={{ paddingRight: 0 }}>
                <FormInput
                  name="comment"
                  id="outlined-comment"
                  placeholder="Write a comment..."
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  rows={1}
                  multiline
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid item xs={2}>
                <IconButton aria-label="send" type="submit">
                  <SendIcon fontSize="small" />
                </IconButton>
              </Grid>
            </Grid>
          </Form>
        </CardContent>
      </Collapse>
    </Card>
  );
};
